<template>
  <div>
    <Landing />
  </div>
</template>

<script>
import Landing from '../components/Landing';

export default {
  components: {
    Landing
  },
};
</script>
